import React from "react";
import { FailureIcon, ProgressIcon, SuccessIcon } from "../components";
export var hourOptions = [
    { name: 0, value: 0 },
    { name: 1, value: 1 },
    { name: 2, value: 2 },
    { name: 3, value: 3 },
    { name: 4, value: 4 }
];
export var minutesOptions = [
    { name: 0, value: 0 },
    { name: 15, value: 15 },
    { name: 30, value: 30 },
    { name: 45, value: 45 }
];
export var daysOptions = [
    { name: 1, value: 1 },
    { name: 2, value: 2 },
    { name: 3, value: 3 },
    { name: 4, value: 4 },
    { name: 5, value: 5 },
    { name: 6, value: 6 },
    { name: 7, value: 7 },
    { name: 8, value: 8 },
    { name: 9, value: 9 },
    { name: 10, value: 10 },
    { name: 11, value: 11 },
    { name: 12, value: 12 },
    { name: 13, value: 13 },
    { name: 14, value: 14 },
    { name: 15, value: 15 }
];
export var passwordExpiryOptions = [
    { name: 30, value: 30 },
    { name: 60, value: 60 },
    { name: 90, value: 90 }
];
export var passwordNotificationOptions = [
    { name: 5, value: 5 },
    { name: 10, value: 10 },
    { name: 15, value: 15 },
    { name: 20, value: 20 }
];
export var deactivationOptions = [
    { name: 30, value: 30 },
    { name: 60, value: 60 },
    { name: 90, value: 90 },
    { name: 120, value: 120 },
    { name: 150, value: 150 },
    { name: 180, value: 180 }
];
export var autoResolveDaysOption = [
    { name: 1, value: 1 },
    { name: 2, value: 2 },
    { name: 3, value: 3 },
    { name: 4, value: 4 },
    { name: 5, value: 5 },
    { name: 6, value: 6 },
    { name: 7, value: 7 },
    { name: 8, value: 8 },
    { name: 9, value: 9 },
    { name: 10, value: 10 },
    { name: 11, value: 11 },
    { name: 12, value: 12 },
    { name: 13, value: 13 },
    { name: 14, value: 14 },
    { name: 15, value: 15 },
    { name: 16, value: 16 },
    { name: 17, value: 17 },
    { name: 18, value: 18 },
    { name: 19, value: 19 },
    { name: 20, value: 20 },
    { name: 21, value: 21 },
    { name: 22, value: 22 },
    { name: 23, value: 23 },
    { name: 24, value: 24 },
    { name: 25, value: 25 },
    { name: 26, value: 26 },
    { name: 27, value: 27 },
    { name: 28, value: 28 },
    { name: 29, value: 29 },
    { name: 30, value: 30 },
    { name: 31, value: 31 },
    { name: 32, value: 32 },
    { name: 33, value: 33 },
    { name: 34, value: 34 },
    { name: 35, value: 35 },
    { name: 36, value: 36 },
    { name: 37, value: 37 },
    { name: 38, value: 38 },
    { name: 39, value: 39 },
    { name: 40, value: 40 },
    { name: 41, value: 41 },
    { name: 42, value: 42 },
    { name: 43, value: 43 },
    { name: 44, value: 44 },
    { name: 45, value: 45 },
    { name: 46, value: 46 },
    { name: 47, value: 47 },
    { name: 48, value: 48 },
    { name: 49, value: 49 },
    { name: 50, value: 50 },
    { name: 51, value: 51 },
    { name: 52, value: 52 },
    { name: 53, value: 53 },
    { name: 54, value: 54 },
    { name: 55, value: 55 },
    { name: 56, value: 56 },
    { name: 57, value: 57 },
    { name: 58, value: 58 },
    { name: 59, value: 59 },
    { name: 60, value: 60 }
];
export var FIELD_UPDATE_ICON = {
    "LOADING": React.createElement(ProgressIcon, null),
    "UPDATE_SUCCESSFUL": React.createElement(SuccessIcon, null),
    "UPDATE_FAILURE": React.createElement(FailureIcon, null)
};
export var MAX_SESSION_TIMEOUT = 240;
export var MIN_SESSION_TIMEOUT = 15;
//# sourceMappingURL=settings.js.map